import React from 'react';
import { useState } from "react";
import Particle from '../Particle';
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.all'

function ContactUs() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone : "",
    message: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbxTV1uxOY14mRFRZDAGePsn5mddTgRrrVSaKRL7wyrwQ55xOFGkYy3u7jK2xIfPJXf_/exec",
        {
          method: "POST",
          body: new URLSearchParams(formData),
        }
      );
      const successdata = document.getElementById("SuccessContact");
      const Msg = document.getElementById("message");
      const Nam = document.getElementById("name");
      const Emale = document.getElementById("email");

      const data = await response.json();
      if (data.result === "success") {
        // We will contact you,shortly
        // Swal.fire({
        //     position: 'top',
        //     icon: 'success',
        //     title: 'Successfully submitted!',
        //     showConfirmButton: false,
        //     timer: 1500
        //   })
        
//start...
successdata.innerHTML = "Successfully Submitted! We will contact you,shortly";
Msg.value = "" ;
Nam.value = "" ;
Emale.value = "" ;
const Toast = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

Toast.fire({
  icon: 'success',
  title: 'Successfully submitted'
})
//end
        //  setTimeout(() => {
        //   window.location.reload();
        //  }, 5000);

        // alert("Form submitted successfully");
        // window.location.reload();
      } else {
        alert("Form submission failed. Please try again later.");
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while submitting the form. Please try again later.");
    }
  };

  return (
    <div >

      <section id="contact">
        <h1 class="section-header pt-2 ">Contact us</h1>
        <p class="text-light pt-2 ">You can get the conversation started by using our contact form or contact us using our details below.</p>
        <div class="contact-wrapper">
          <form id="contact-form" class="form-horizontal" role="form" onSubmit={handleSubmit}>

            <div class="form-group pb-3">
              <div class="col-sm-12">
                <input type="text" class="form-control" id="name" placeholder="NAME" value={formData.name}
                  onChange={handleInputChange} name="name" required />
              </div>
            </div>

            <div class="form-group pb-3">
              <div class="col-sm-12">
                <input type="email" class="form-control" id="email" placeholder="EMAIL" name="email" value={formData.email}
                  onChange={handleInputChange} required />
              </div>
            </div>

            <div class="form-group pb-3">
              <div class="col-sm-12">
                <input class="form-control" type="tel" id="phone" name="phone"  placeholder="Mobile number.." value={formData.phone}
                  onChange={handleInputChange}  required />
              </div>
            </div>

            <textarea class="form-control" rows="10" placeholder="MESSAGE..." id="message" name="message" minlength="5" autofocus value={formData.message}
              onChange={handleInputChange} required></textarea>

            <button class="btn btn-primary send-button" id="submit" type="submit" value="SEND">
              <div class="alt-send-button">
                <i class="fa fa-paper-plane"></i><span class="send-text">SEND</span>
              </div>

            </button>
             <label style={{color: "green",fontWeight: 'bold'}} className='mt-2' id='SuccessContact'></label>
          </form>



          <div class="direct-contact-container">

            <ul class="contact-list">
              <li class="list-item"><i class="fa fa-map-marker fa-2x"><span class="contact-text place">Trivandrum,Kerala,IN</span></i></li>

              <li class="list-item"><i class="fa fa-phone fa-2x"><span class="contact-text phone"><a href="tel:1-212-555-5555" title="Give me a call">(+91) 892109****</a></span></i></li>

              <li class="list-item"><i class="fa fa-envelope fa-2x"><span class="contact-text gmail"><a href="mailto:#" title="Send me an email">akhiltrackgen2022@gmail.com</a></span></i></li>

            </ul>

            <hr />
            {/* <ul class="social-media-list">
              <li><a href="https://akhiljptvm.github.io/" target="_blank" class="contact-icon">
                <i class="fa-brands fa-github" aria-hidden="true"></i></a>
              </li>
              <li><a href="https://www.linkedin.com/in/akhiljptvm" target="_blank" class="contact-icon">
                <i class="fa-brands fa-linkedin" aria-hidden="true"></i></a>
              </li>
              <li><a href="https://twitter.com/Akhiljptvm" target="_blank" class="contact-icon">
                <i class="fa-brands fa-twitter" aria-hidden="true"></i></a>
              </li>

              <li>
                <a href="https://www.instagram.com/akhil.codemusic/" target="_blank" class="contact-icon">
                <i class="fa-brands fa-instagram" aria-hidden="true"></i>
                </a>
              </li>
            </ul> */}
            <hr />

            {/* <div class="copyright">&copy; ALL OF THE RIGHTS RESERVED</div> */}

            <Particle />
          </div>

        </div>

      </section>

{/* map */}

      <section class="map_sec">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="map_inner">
                <h4>Find Us on Google Map</h4>
                <p style={{fontSize:"18px"}}>Locate us easily on Google Maps and get directions to our location.</p>
                <div class="map_bind">
                  {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d471220.5631094339!2d88.04952462217592!3d22.6757520733225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f882db4908f667%3A0x43e330e68f6c2cbc!2sKolkata%2C%20West%20Bengal!5e0!3m2!1sen!2sin!4v1596988408134!5m2!1sen!2sin" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> */}
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126271.83043336496!2d76.84176556505498!3d8.499894071541737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05bbb805bbcd47%3A0x15439fab5c5c81cb!2sThiruvananthapuram%2C%20Kerala!5e0!3m2!1sen!2sin!4v1681563459560!5m2!1sen!2sin" width="100%" height="450" frameborder="0" aria-hidden="false" tabindex="0" allowfullscreen="" loading="lazy"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="call-buton call-buton2"><a class="cc-calto-action-ripple"
      //  href="tel:918921093869"
       href="https://api.whatsapp.com/send?phone=918921093869&text=Hi%20there!%20Thanks%20for%20reaching%20out%20.%20We%27re%20excited%20to%20connect%20with%20you%20and%20help%20you%20bring%20your%20online%20presence%20to%20life.%20We%20provide%20high-quality%20website%20design%20and%20development%20services%20to%20businesses%20of%20all%20sizes.%20Whether%20you%27re%20looking%20to%20create%20a%20new%20website%20or%20improve%20an%20existing%20one%2C%20we%27re%20here%20to%20help.%20Feel%20free%20to%20ask%20us%20any%20questions%20you%20have%20about%20our%20services%2C%20and%20we%27ll%20do%20our%20best%20to%20provide%20you%20with%20the%20information%20you%20need.%20Let%27s%20work%20together%20to%20build%20the%20perfect%20website%20for%20your%20business!"
       ><i class="fa fa-phone"></i><span class="num"></span>
      </a>
      </section>
    </div>
  )
}

export default ContactUs